import dynamic from "next/dynamic";
import { useRouter } from "next/router";

import classNames from "classnames";

import CustomCard from "components/CustomCard";
import { profileUrl } from "components/ProfilePageLayout";
import { Tab, Tabs } from "components/Tabs";
import { useApi } from "hooks/useApi";

const ProfilePageOverview = dynamic(() => import("./ProfilePageOverview"));
const ProfilePageStatistics = dynamic(() => import("./ProfilePageStatistics"));

type ProfilePageAboutProps = {};

const ProfilePageAbout = ({}: ProfilePageAboutProps) => {
  const router = useRouter();
  const slug = router.query.slug as string;
  const currentTab = router.query.tab;

  const isCompany = router.route.startsWith("/companies/[slug]");

  const { data: profile } = useApi(profileUrl(slug, isCompany));

  return (
    <>
      <Tabs
        className={classNames(
          "justify-center my-[10px]",
          "md:justify-start md:my-0"
        )}
      >
        <Tab
          href={`/${isCompany ? "companies" : "profiles"}/${slug}/about`}
          active={!currentTab}
        >
          Overview
        </Tab>
        {profile?.showStatisticsTab && (
          <Tab
            href={`/${
              isCompany ? "companies" : "profiles"
            }/${slug}/about?tab=statistics`}
            active={currentTab === "statistics"}
          >
            Statistics
          </Tab>
        )}
      </Tabs>
      <CustomCard
        className={classNames(
          "mx-0 mt-0 p-0 rounded-none",
          "md:rounded-xl md:mt-[15px]"
        )}
      >
        {currentTab === "statistics" ? (
          <ProfilePageStatistics />
        ) : (
          <ProfilePageOverview />
        )}
      </CustomCard>
    </>
  );
};

export default ProfilePageAbout;
